import * as React from "react";
import styled, { css } from "styled-components";
import { forwardRef } from "react";
import Icon from "components/common/Icon";
import { Button } from "components/bootstrap";
import Tooltip from "components/common/Tooltip";
const Wrapper = styled(Button)(
  ({ theme, disabled, bsStyle }) => css`
    ${bsStyle === "transparent" && css`
      padding: 0 3px;
      color: ${disabled ? theme.colors.gray[90] : theme.colors.gray[60]};
    `}
  `
);
const handleClick = (onClick, disabled, e) => {
  if (disabled) {
    return;
  }
  if (typeof onClick === "function") {
    onClick(e);
  }
};
const StyledIcon = styled(Icon)`
  line-height: inherit;
`;
const IconButton = ({
  title,
  ariaLabel = void 0,
  onClick = void 0,
  focusable = true,
  className = void 0,
  disabled = false,
  iconType = void 0,
  bsStyle = "transparent",
  "data-testid": dataTestId = void 0,
  size = "xs",
  showTitle = false,
  href = void 0,
  target = void 0,
  rel = void 0,
  allowClickWhenDisabled = false,
  showTooltip = true,
  ...rest
}, ref) => {
  const button = /* @__PURE__ */ React.createElement(
    Wrapper,
    {
      ref,
      tabIndex: focusable ? 0 : -1,
      "data-testid": dataTestId,
      "aria-label": ariaLabel != null ? ariaLabel : title,
      "aria-disabled": disabled,
      onClick: (e) => handleClick(onClick, disabled, e),
      className,
      type: "button",
      bsSize: size,
      bsStyle,
      href,
      target,
      rel,
      allowClickWhenDisabled,
      disabled
    },
    /* @__PURE__ */ React.createElement(StyledIcon, { type: iconType, size: bsStyle === "transparent" ? "lg" : void 0, ...rest }),
    showTitle && ` ${title}`
  );
  if (!showTooltip || showTitle && !disabled) {
    return button;
  }
  return /* @__PURE__ */ React.createElement(Tooltip, { label: title, position: "top", openDelay: 750 }, button);
};
export default forwardRef(IconButton);
